export const PERMISSION_MODULES = [
  { index: 0, label: 'Khách hàng' },
  { index: 1, label: 'Cài đặt' },
  { index: 2, label: 'Vietlott' },
  { index: 3, label: 'XSKT' },
  { index: 4, label: 'Loto' },
]

export function normalizePermission(permission) {
  const raw = permission || '00000'
  return `${raw}00000`.slice(0, 5)
}

export function permissionToFlags(permission) {
  return normalizePermission(permission).split('')
}

export function flagsToPermission(flags) {
  return flags.map((f) => (f === '1' ? '1' : '0')).join('')
}

export function persistAdminSession(data) {
  if (!data) return
  if (data.email) {
    localStorage.setItem('email', data.email)
  }
  if (data.permission !== undefined && data.permission !== null) {
    localStorage.setItem('permission', data.permission)
  }
  if (data.isSuperAdmin !== undefined) {
    localStorage.setItem('isSuperAdmin', data.isSuperAdmin === 1 ? '1' : '0')
  }
}

export function clearAdminSession() {
  localStorage.removeItem('email')
  localStorage.removeItem('permission')
  localStorage.removeItem('isSuperAdmin')
}

export function isSuperAdminUser() {
  return localStorage.getItem('isSuperAdmin') === '1'
}
